import MenuLayout from "../../layouts/MenuLayout";
import { useEffect, useRef } from "react";
import { becomeCoachSchema } from "../../utils/schema";

import { useNavigate } from "react-router-dom";
import { handleCoachSignUp } from "../../redux/features/coach/actions/authAction";

import { Formik } from "formik";

import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const PostJob = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialState = {
    full_name: "",
    email: "",
    phone_number: "",
    category_id: "",
    format: "",
    tagline: "",
    bio: "",
    reason: "",
    year_of_experience: "",
    profile_image: "",
    cv: "",
    certificate: "",
  };

  // const [navBarDemo, setNavBarDemo] = useState("Founder");
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  // useEffect(() => {
  //   dispatch(fetchCoachList());
  // }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType = item?.category_name
      ?.toLowerCase()
      .includes("founder");
    return matchCoachingType;
  });

  const handleBecomeCoachDetails = (values) => {
    const formData = new FormData();
    formData.append("year_of_experience", parseInt(values.year_of_experience));
    formData.append("profile_image", values?.profile_image);
    formData.append("phone_number", values.phone_number);
    formData.append("category_id", values.category_id);
    formData.append("full_name", values.full_name);
    formData.append("tagline", values?.tagline);
    formData.append("format", values.format);
    formData.append("reason", values?.reason);
    formData.append("email", values.email);
    formData.append("bio", values?.bio);

    (values?.certificate || []).forEach((file) => {
      formData.append("certificate", file);
    });

    (values?.cv || []).forEach((file) => {
      formData.append("cv", file);
    });
    const callback = (response) => {
      if (response) {
        navigate(coachPaths?.Login);
      }
    };
    dispatch(handleCoachSignUp({ payload: formData, callback }));
  };
  if (isLoading2) {
    return <Loader />;
  };
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section class="ct_nuglow_subsciption_left_bg mt-5">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div className="col-lg-7 mb-4 mb-lg-0 px-0">
                  <img
                    src="assets/img/post_a_job_banner_bg.png"
                    className="ct_img_h_371 "
                  />
                </div>
                <div className="col-lg-5 mb-4 mb-lg-0 ps-0">
                  <div className="ct_pt_98_px_60_pb_98">
                    <h2
                      className="ct_fs_32 ct_mb_50 text-white"
                      style={{ maxWidth: "358px" }}
                    >
                      Post a Job, Find the{" "}
                      <span className="ct_yellow_text"> Right </span> Talent
                    </h2>
                    <p
                      className=" text-white ct_fs_20_new ct_fw_300"
                      style={{ maxWidth: "457px" }}
                    >
                      Quickly share your needs and connect with top freelancers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className=" ct_px_40 ct_pb_100 ct_pt_100 ">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-xxl-6 col-xl-6 col-lg-6 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <h4 className="ct_fs_32 mb-3">Job Details</h4>
                  <p className="ct_fs_20" style={{ maxWidth: "691px" }}>
                    Add a clear description, required skills, and expected
                    timeline to help freelancers understand your project.
                  </p>
                  <Formik
                    initialValues={initialState}
                    validationSchema={becomeCoachSchema}
                    onSubmit={(values, actions) => {
                      handleBecomeCoachDetails(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                      setFieldError,
                      setTouched,
                    }) => (
                      <form action={handleSubmit} class="ct_mt_60">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Job Title
                              </label>
                              <input
                                type="text"
                                placeholder="e.g Senior UI/UX Designer"
                                class="form-control ct_input ct_input_h_60 ct_fs_14"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label class="d-block mb-2 ct_fs_14">
                                Industry
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>
                                    Information Technology (IT) & Software
                                  </option>
                                  <option>Finance & Banking</option>
                                  <option>Healthcare & Pharmaceuticals</option>
                                  <option>Education & Training</option>
                                  <option>Engineering & Manufacturing</option>
                                  <option>Retail & E-commerce</option>
                                  <option>Hospitality & Tourism</option>
                                  <option>
                                    Marketing, Media & Communications
                                  </option>
                                  <option>Transportation & Logistics</option>
                                  <option>Energy & Utilities</option>
                                  <option>Legal Services</option>
                                  <option>Agriculture & Food Industry</option>
                                  <option>Government & Public Sector</option>
                                  <option>Nonprofit & NGOs</option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Category
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>Category</option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Candidate location
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>Candidate location </option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Candidat availability
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>Full Time </option>
                                  <option>Part Time </option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-12">
                            <p
                              className="ct_fs_16 mb-4 ct_darkblue_text ct_text_op_7 mt-3"
                              style={{ maxWidth: "350px" }}
                            >
                              If you accept applicants from anywhere, please
                              select ‘Worldwide’ as the location preference.
                            </p>
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Job Description / Required Skills
                              </label>
                              <textarea
                                class="form-control ct_input h-auto ct_fs_14"
                                rows="5"
                              ></textarea>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Years of Experience
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>Select </option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Minimum Educational Qualification
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>Select </option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Salary Currency
                              </label>
                              <input
                                type="text"
                                placeholder="USD$"
                                class="form-control ct_input ct_input_h_60 ct_fs_14"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Minimum Salary / Year
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>e.g 5000 </option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Maximum Salary / Year
                              </label>
                              <div className="d-flex flex-column gap-2 position-relative">
                                <select className="form-control ct_input ct_fs_14 ct_input_grey_border_1 ct_border_radius_20 ct_input_h_60">
                                  <option>e.g 100000</option>
                                </select>
                                <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Start Date
                              </label>
                              <input
                                type="date"
                                class="form-control ct_input ct_input_h_60 ct_fs_14"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group mb-4">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                End Date (Optional)
                              </label>
                              <input
                                type="date"
                                class="form-control ct_input ct_input_h_60 ct_fs_14"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row ct_mt_60 gap-5">
                          <div className="col-md-12">
                            <h4 className="ct_fs_30 ct_darkblue_text ct_mb_20">
                              Pricing Plan
                            </h4>
                            <p className="mb-0 ct_fs_18 ct_darkblue_text" onClick={openSignUp}>
                              Already purchased a job posting plan? Enter your
                              Order ID below. If not, visit our pricing page to
                              get started.
                            </p>
                            <div className="form-group ct_mt_40">
                              <label for="" class="d-block mb-2 ct_fs_14">
                                Order ID
                              </label>
                              <input
                                type="text"
                                placeholder="Insert your order id here"
                                class="form-control ct_input ct_input_h_60 ct_fs_14"
                              />
                            </div>
                            <p
                              className="ct_fs_16 ct_darkblue_text mb-0 ct_mt_16 ct_text_op_7"
                              style={{ maxWidth: "710px" }}
                            >
                              Once you submit, we’ll review your listing. If we
                              need more details, we’ll reach out. After
                              approval, your job post goes live and you’ll
                              receive an email notification.
                            </p>
                          </div>
                        </div>

                        <div className="text-end mt-5">
                          <button
                            type="button"
                            class="ct_yellow_btn  px-5 ms-auto"
                            onClick={handleSubmit}
                          // data-bs-toggle="modal" data-bs-target="#ct_submit_modal"
                          >
                            {" "}
                            Submit My Application
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0  offset-lg-1"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="ct_need_help_card ct_mt_100">
                    <h4 className="ct_fs_24 ct_mb_20">Craft the Perfect Job</h4>
                    <ul>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Use a clear, specific job title that reflects the role
                        and level skip vague or trendy terms.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Describe what makes the role exciting or unique to help
                        your post stand out.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        List the main responsibilities, skills required, and
                        what success looks like.
                      </li>
                      <li className="ct_fs_18" style={{ maxWidth: "408px" }}>
                        Specify if the job is remote, hybrid, or onsite to
                        manage expectations from the start.
                      </li>
                    </ul>
                    <p className="ct_fs_18 mt-4">
                      Need help{" "}
                      <span
                        className="ct_yellow_text ct_cursor_pointer"
                        onClick={() => {
                          navigate(coachPaths?.ContactUs, {
                            state: { data: "landing" },
                          });
                        }}
                      >
                        Contact Us
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg      ct_p_111_y_106 ct_mt_100"
            style={{ backgroundColor: "#219EBC" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Craft Your Job Post</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "639px" }}
                >
                  Need help? Our team is here to guide you in writing clear,
                  compelling listings that attract top talent.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                  Get Expert Help
                </a>
              </div>
            </div>
          </section>

          <div className="ct_post_job_light_blue_shape ct_mb_100 ">
            <section class="  ct_px_40 ct_py_130 ">
              <div class="container-fluid">
                <div class="row">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="d-grid h-100 pt-2 pb-5">
                      <h2
                        class="ct_fs_40 ct_darkblue_text"
                        style={{ maxWidth: "300px" }}
                      >
                        Real Stories, real{" "}
                        <span class="ct_yellow_text">success</span>
                      </h2>
                      <div className="ct_arrows mt-auto">
                        <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                          <i class="fa-solid fa-arrow-left"></i>
                        </button>
                        <button className="ct_next ct_arrow_btn" ref={nextRef}>
                          <i class="fa-solid fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      spaceBetween={20}
                      slidesPerView={1}
                      loop={true}
                      autoplay={{ delay: 2500 }}
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                      }}
                      className="ct_real_stories_slider"
                    >
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="../assets/img/reacl_stories_img_slider_123.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>
                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              From Passion to Profession
                            </h3>
                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              Starting as a freelance developer felt
                              overwhelming. But through NuGlow, I built a solid
                              portfolio and connected with startups that valued
                              my work. Today, I lead a team and help others find
                              their way too.
                            </p>
                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Amelia Carter
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Head of Product at BrightWave Solutions
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="../assets/img/pexels-fauxels-3182834.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>
                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Dream Clients, Real Impact
                            </h3>
                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              With NuGlow, I went from inconsistent gigs to landing long-term clients. The exposure and experience helped me grow into a leadership role much faster than I imagined
                            </p>
                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Sophia Bennett
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Head of Digital Products at NovaSphere
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="../assets/img/pexels-fauxels-31828341245.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Breaking Through the Noise
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              I struggled for years to get noticed. NuGlow changed everything my first premium project opened doors I never thought possible. Now, I manage large-scale product launches across industries.
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Ethan Moore
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Senior Product Manager at VeloTech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </section>
            <section class=" ct_px_40 pt-0 ">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_cnt">
                      <h2 class=" ct_fs_32  ct_mb_60">
                        Frequently asked questions
                      </h2>

                      <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                        <div class="accordion" id="faq_accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_one"
                                aria-expanded="false"
                                aria-controls="collapsefaq_one"
                              >
                                How do I get started as a freelancer on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_one"
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqtwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Two"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                What types of projects can I find on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Two"
                              class="accordion-collapse collapse "
                              aria-labelledby="faqtwo"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqthree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Three"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Three"
                              >
                                How does payment work?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Three"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqthree"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Four"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Four"
                              >
                                What support does NUVIO provide to freelancers?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Four"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFour"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  These costs can spiral but that didn't seem
                                  fair. So our prices work differently. Small
                                  businesses often need to do similar things:
                                  sell online, book appointments, make
                                  reservations. So we offer cheaper,
                                  pre-packaged Studio Store apps - that solve
                                  these brilliantly.
                                </p>
                                <p class="ct_fs_20 mb-0 ct_line_h_30">
                                  If you’re doing something new, on a bigger
                                  scale, or need more flexibility, then Builder
                                  Studio is for you. Prices vary depending on
                                  the features you need but again, you’ll know
                                  exactly what you’re paying upfront.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_about_img">
                      <img
                        src="assets/img/pexels-fauxels-318283_896.png"
                        class="ct_img_h_617"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg   ct_looking_for_work_bg_left   ct_p_111_y_106 ct_mt_100"
            style={{ backgroundColor: "var(--orange)", marginBottom: "200px" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Create a Job Listing That Works</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "711px" }}
                >
                  Our expert team is ready to help you craft precise, engaging
                  job posts that bring in the best candidates.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() => navigate(coachPaths?.ContactUs)}
                >
                  Get Expert Help
                </a>
              </div>
            </div>
          </section>
        </>
      )}
    </MenuLayout>
  );
};

export default PostJob;
